// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IVector2 {
	x: number;

	y: number;

	$type?: string | undefined;
}
export class Vector2 {
	constructor(data?: IVector2) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	x: number = 0;

	y: number = 0;

	static $type: string = "System.Numerics.Vector2, ";
	$type?: string | undefined = Vector2.$type;
}

